<template>
<div>
    <h1 class="pt-2 text-sm"> {{$t('form.sav.service_apres_vente')}} </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <div class="items-center md:flex">
            <img class="w-full mb-3 md:w-auto md:h-32" src="https://disticloudfiles.net/img/savinfo/default/sav.webp" alt="">
            <div class="ml-3">
                <h3 class="font-light">{{$t('form.sav.reparation')}}</h3>
                <div class="my-2 text-lg font-semibold" v-html="$tt(texte)"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'sav',
    extends: FormCardExtension,

    data() {
        return {
            texte: null
        }
    },

    methods: {
        async init() {
            let setCaseData = this.$formTool.getFormData('set-case')
            if (setCaseData) {
                this.texte = await apiService.text('title_sav', this.$formTool.getFormData('proc').id, this.$formTool.getFormData('proc').id, JSON.parse(setCaseData).id_case)
            }  else {
                this.texte = this.$t('form.aucun_process.aucune_procedure_a_completer')
            }

            // Check if data
            this.nextBlock = this.getNextBlock()

            this.emitChange()
        },

        getNextBlock() {
            if (this.$formTool.getFormData('proc').emballage.mandatory == "1") {
                return this.$formTool.blockData(this.$options.name).next.packaging
            }
            return this.$formTool.blockData(this.$options.name).next.stations
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/SavCard.vue